import { updateQuantityInput, updateSelectedPercentage } from 'actions/placeorder';
import {
  calculatedQuantityOnDropdownChangeSelector,
  optionsMaxQuantitySize,
  sideSelection,
  spotMaxQuantititySize,
} from 'selectors/placeOrderSelector';
import { selectedProductSelector } from 'selectors/tradeSelectors';
import { ContractType } from 'types/IProducts';

import { convertQuantityValueToNumberOfContracts } from '../../../formulae';
import { trackQuantityInput } from './mixpanels';

const updatePercentageOnQtyChange = qtyInput => (dispatch, getState) => {
  const state = getState();
  const selectedProduct = selectedProductSelector(state);
  const spotMaxSize = spotMaxQuantititySize(state);
  const maxSize = optionsMaxQuantitySize(state);
  const side = sideSelection(state);
  let calculatedPercentage;
  const qtyInContracts = convertQuantityValueToNumberOfContracts(
    qtyInput ?? 0,
    selectedProduct ?? {},
    side
  );

  if (selectedProduct?.contract_type === ContractType.Spot) {
    calculatedPercentage = qtyInput && spotMaxSize ? qtyInput / spotMaxSize : 0;
  } else {
    calculatedPercentage = qtyInContracts && maxSize ? qtyInContracts / maxSize : 0;
  }

  // Find the closest standard percentage
  const closest = Math.floor(calculatedPercentage * 100);
  if (closest >= 9 && closest <= 11) {
    dispatch(updateSelectedPercentage('10%'));
  } else if (closest >= 24 && closest <= 26) {
    dispatch(updateSelectedPercentage('25%'));
  } else if (closest >= 49 && closest <= 51) {
    dispatch(updateSelectedPercentage('50%'));
  } else if (closest >= 74 && closest <= 76) {
    dispatch(updateSelectedPercentage('75%'));
  } else if (closest >= 99 && closest <= 101) {
    dispatch(updateSelectedPercentage('100%'));
  } else {
    dispatch(updateSelectedPercentage(null));
  }
};

const quantityChangeEpic = value => (dispatch, getState) => {
  const state = getState();
  const selectedProduct = selectedProductSelector(state);

  // save it to redux
  dispatch(updateQuantityInput(value));
  // on change track mix panel events every 5 minutes
  trackQuantityInput(selectedProduct);

  // change percentage on qty change
  dispatch(updatePercentageOnQtyChange(value));
};

const updateQuantityInputFromContracts = qtyInContracts => (dispatch, getState) => {
  const state = getState();
  const valueToFill = calculatedQuantityOnDropdownChangeSelector(state, qtyInContracts);
  dispatch(quantityChangeEpic(valueToFill));
};

export default quantityChangeEpic;

export { updatePercentageOnQtyChange, updateQuantityInputFromContracts };
